import { NamedComplexEnumItem } from '../../utils/complexEnum/NamedComplexEnumItem'

export class CASPacketAttachmentOrderItem<
  ID extends Lowercase<string>,
  Name extends string,
  Field extends string,
  Direction extends 'asc' | 'desc'
> extends NamedComplexEnumItem<ID, Name> {
  /**
   * The field name to sort by (used for both ImageDownload and PDFDownload file
   * types).
   */
  readonly field: Field

  /**
   * The sort direction (ascending or descending).
   */
  readonly direction: Direction

  constructor({
    field,
    direction,
    ...rest
  }: Pick<
    CASPacketAttachmentOrderItem<ID, Name, Field, Direction>,
    'id' | 'name' | 'field' | 'direction'
  >) {
    super(rest)
    this.field = field
    this.direction = direction
  }
}
